import * as React from 'react';

interface CharacterCounterProps {
  characterCount?: number;
  characterLimit: number;
}

export const CharacterCounter: React.FC<CharacterCounterProps> = ({ characterCount = 0, characterLimit }) => {
  const isOverflow = characterCount >= characterLimit;

  return (
    <span>
      <span className={isOverflow ? 'overflow' : ''}>{characterCount}</span>/<span>{characterLimit}</span>
    </span>
  );
};
